import Constant from '@/common/constant/Constant';

import { getFormMasterListByProject } from '@/service/formManagementService';
import { searchTicketKnowledgeListByFilter } from '@/service/ticketKnowledgeService';


import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { getListMasterKnowledgeTicketOfFormWithoutAuthen, queryListMasterKnowledgeTicketOfForm, queryListMasterKnowledgeTicketOfFormWithPagination } from '@/service/ticketService';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import _ from 'lodash'

/**
 * Get form master list
 * @param {*} argsCommon
 */
export const getFormMasterList = argsCommon => {
    argsCommon.setIsLoading(true);
    getFormMasterListByProject(argsCommon.API, argsCommon.projectDetail.affiliationOrganization, argsCommon.projectDetail.id)
        .then(resGetListMasterForm => {
            
            let listFormMaster = Utils.sortByCreatedAtDesc(resGetListMasterForm);

            // get list form master shared
            const listFormMasterOutOrg = argsCommon?.listFormOfProject?.filter(form => {
                return (
                    (form.type === Constant.FORM_TYPE.FORM_MASTER) &&
                    form.affiliationOrganization !==
                        argsCommon.projectDetail.affiliationOrganization &&
                    form?.usingProjects?.includes(argsCommon.projectDetail.id)
                );
            });

            const listFormGlobalInCorp = argsCommon?.listFormOfProject?.filter(form => {
                return (
                    (form.type === Constant.FORM_TYPE.FORM_MASTER) &&
                    form.affiliationOrganization ===
                        argsCommon.projectDetail.affiliationOrganization &&
                    form?.usingProjects?.includes(argsCommon.projectDetail.id) && form.usage === Constant.FORM_USAGE.FORM_GLOBAL
                );
            });
            

            listFormMaster = !Utils.isEmptyArray(listFormMasterOutOrg) ? [...listFormMaster,...listFormMasterOutOrg] : listFormMaster
            listFormMaster = !Utils.isEmptyArray(listFormGlobalInCorp) ? [...listFormMaster,...listFormGlobalInCorp] : listFormMaster
            argsCommon.setFormMasterList(listFormMaster);
        })
        .catch(err => {
            argsCommon.setFormMasterList([]);
        })
        .finally(() => {
            argsCommon.setIsLoading(false);
        });
};

const getTitle = (settingTitle) =>{
    let title = '';
    settingTitle?.forEach(element => {
        if(!element.isBreak){
            title = title +element.text
        }
    })
    return title
}

/**
 * Get ticket master knowledge list
 * @param {*} argsCommon 
 */
export const getTicketMasterKnowledgeList = argsCommon => {
    

    // let indexFormMasterSelected = Utils.findIndexInArrayById(argsCommon.formMasterIdSelected, argsCommon.formMasterList);

    // if (indexFormMasterSelected === -1) {
    //     argsCommon.setTicketKnowledgeMasterList([]);
    //     return;
    // }

    argsCommon.setIsLoading(true);
    // let filterInput = {
    //     affiliationOrganization: argsCommon.formMasterList[indexFormMasterSelected].affiliationOrganization,
    //     formIdList: [argsCommon.formMasterList[indexFormMasterSelected].id]
    // };


    let queryProjectId;
    const formMasterSelected = argsCommon.formMasterList.find(form => form.id === argsCommon.formMasterIdSelected);
    if (Utils.isEmptyObject(formMasterSelected)) {
        queryProjectId = argsCommon.projectDetail.id;
    } else {
        queryProjectId = argsCommon.currentUpdateField.affiliationProject;
    }

    // call api
    queryListMasterKnowledgeTicketOfForm(argsCommon.API, argsCommon.corporationDetail.id, queryProjectId, argsCommon.formMasterIdSelected,{
        userId: argsCommon.userDetail.id,
        projectInuse: argsCommon.projectInuseDetail.id,
        organizationInuse: argsCommon.corporationDetail.id
    })
        .then(ticketMasterList => {
            ticketMasterList = Utils.sortByCreatedAtAsc(ticketMasterList);
            let listMasterTicketWithTitle = [];
            ticketMasterList.forEach((ticket) =>{
                let ticketClone = {...ticket}
                ticketClone.name = getTitle(ticket.settingTitle);
                listMasterTicketWithTitle.push(ticketClone);
            })
            let migrateTicketId = listMasterTicketWithTitle.map(ticket => ticket.id);
            argsCommon.setTicketKnowledgeMasterList(listMasterTicketWithTitle);
        })
        .catch(err => {
            argsCommon.setTicketKnowledgeMasterList([]);
        })
        .finally(() => {
            argsCommon?.setIsLoading(false);
        });
};

const checkDisplayLink = (
    ticket,
    projectInuseId,
    orgId,
    userId,
    b2bCustomerList,
    b2bSupportList
) => {
    let isDisplay = false;
    const viewPermission = ticket.viewPermission;
    const additionalViewPermission = Utils.convertJSONDataToObject(ticket.additionalViewPermission);

    let listProjectId = [];
    for (const key in additionalViewPermission) {
        listProjectId = [...listProjectId, ...additionalViewPermission[key]];
    }
    if (listProjectId.includes(projectInuseId)) {
        return true;
    }
    viewPermission?.forEach(permission => {
        switch (`${permission}`) {
            case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY:
                if (userId === ticket.creator) isDisplay = true;
                break;
            case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT:
                if (projectInuseId === ticket.affiliationProject) isDisplay = true;
                break;
            case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG:
                if (orgId === ticket.affiliationOrganization) isDisplay = true;

                break;
            case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER:
                if (b2bSupportList.includes(ticket.affiliationProject)) isDisplay = true;
                break;
            case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT:
                if (b2bCustomerList.includes(ticket.affiliationProject)) isDisplay = true;
                break;
            case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC:
                isDisplay = true;
                break;
            default:
                break;
        }
    });

    return isDisplay;
};

/**
 * Build item tag list
 * @param {*} argsCommon
 * ex: {title: '1', value: 'tag_b063dc93-136f-4279-af5b-d17adaf4f408', no: 1, hitNumber: 0}
 */
export const buildItemTagList = async (argsCommon, setIsDoneInitData,userInfo) => {
    let tagField = argsCommon.tagField;
    const isNotAuthen = argsCommon?.isNotAuthen;

    if (setIsDoneInitData) {
        setIsDoneInitData(false);
    }
    switch (tagField.structure.settingSelectItem) {
        case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
            if (Utils.isEmptyArray(tagField.structure?.listItem)) {
                argsCommon.setTagList([]);
                break;
            }

            let ticketIdList = [];
            tagField.structure?.listItem.forEach(item => {
                ticketIdList.push(item.itemId);
            });

            if (isNotAuthen) {
                getListMasterKnowledgeTicketOfFormWithoutAuthen(
                    argsCommon.API,
                    argsCommon.tagField.affiliationOrganization,
                    argsCommon.tagField.affiliationProject,
                    argsCommon.tagField.relatedMasterForm
                )
                    .then(ticketMasterList => {
                        let itemTagList = [];
                        let itemSelectedList = [];
                        ticketMasterList = ticketMasterList?.map(ticket => {
                            if(ticket?.viewPermission?.includes("PUBLIC")){
                                ticket.userHasViewPermission = true
                            }else{
                                ticket.userHasViewPermission = false
                            }

                            return ticket
                        })
                        ticketMasterList.forEach(ticket => {
                            let currentItem = tagField.structure?.listItem?.find(
                                o => o.itemId === ticket.id
                            );
                            if (!Utils.isEmptyObject(currentItem)) {
                                const isDisplayLink = checkDisplayLink(
                                    ticket,
                                    argsCommon.projectDetail.id,
                                    argsCommon.corporationDetail.id,
                                    argsCommon.userDetail.id,
                                    argsCommon.b2bCustomerList,
                                    argsCommon.b2bSupportList
                                );

                                let itemData = {
                                    no: Utils.isEmpty(currentItem) ? 1 : currentItem.order,
                                    hitNumber: Utils.isEmpty(currentItem)
                                        ? 0
                                        : currentItem.hitNumber,
                                    title: getTitle(ticket.settingTitle),
                                    value: ticket.id,
                                    isActive:
                                        currentItem.isActive && Utils.isEmpty(ticket?.deletedAt)
                                            ? true
                                            : false,
                                    isDisplayLink: isDisplayLink,
                                    isDeleted: !Utils.isEmpty(ticket?.deletedAt) ? true : false,
                                    isDisplay: ticket.userHasViewPermission ? true : false
                                };

                                if (currentItem.isActive && ticket.userHasViewPermission) {
                                    itemTagList.push(itemData);
                                }

                                if (
                                    !Utils.isEmptyArray(argsCommon.defaultValue) &&
                                    argsCommon.defaultValue.includes(ticket.id)
                                ) {
                                    itemSelectedList.push(itemData);
                                }else if(!tagField.structure?.isMultiple){
                                    itemSelectedList.push(Constant.FIELD_UI_SELECT_DEFAULT_ITEM)
                                }
                            }
                        });

                        if (!tagField.structure?.isMultiple) {
                            let selectedItem =  Constant.FIELD_UI_SELECT_DEFAULT_ITEM;
                            let indexSelected = 0;
                            if (!Utils.isEmptyArray(itemSelectedList)) {
                                for (let i = 0; i < itemSelectedList.length; i++) {
                                    const itemSelected = itemSelectedList[i];
                                    if (itemSelected.isActive) {
                                        selectedItem = itemSelected;
                                        break;
                                    }
                                }
                            }

                            if (!Utils.isEmptyObject(selectedItem)) {
                                indexSelected = itemTagList.findIndex(
                                    item => item.value === selectedItem.value
                                );
                                itemSelectedList = [selectedItem];
                            } else if (!Utils.isEmptyObject(itemTagList)) {
                                indexSelected = 0;
                                selectedItem = itemTagList[0];
                                itemSelectedList = [selectedItem];
                            } else {
                                itemSelectedList = [];
                            };

                            argsCommon.setDefaultIndexChecked(indexSelected);

                            if (
                                tagField.structure.optionType ===
                                Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
                                || (tagField.structure.optionType === Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE && argsCommon.enableShowMore)
                            ) {
                                itemTagList = [
                                    Constant.FIELD_UI_SELECT_DEFAULT_ITEM,
                                    ...itemTagList
                                ];
                                if (Utils.isEmptyArray(itemSelectedList) && !tagField.structure?.isMultiple)
                                    itemSelectedList.push(Constant.FIELD_UI_SELECT_DEFAULT_ITEM);
                            }
                        }


                        argsCommon.setTagList([...itemTagList]);
                        argsCommon.setTagValue(itemSelectedList);
                    })
                    .catch(err => {
                        
                        argsCommon.setTagList([]);
                        argsCommon.setTagValue([]);
                    })
                    .finally(() => {
                        // todo
                        if (setIsDoneInitData) {
                            setIsDoneInitData(true);
                        }
                        if (argsCommon.setIsLoading) {
                            argsCommon.setIsLoading(false);
                        }
                    });
            } else {
                // call api
                queryListMasterKnowledgeTicketOfFormWithPagination(
                    argsCommon.API,
                    argsCommon.tagField.affiliationOrganization,
                    argsCommon.tagField.affiliationProject,
                    argsCommon.tagField.relatedMasterForm,
                    {
                        userId: userInfo?.userDetail.id,
                        projectInuse: userInfo?.projectDetail.id,
                        organizationInuse: userInfo?.corporationDetail.id
                    },
                    argsCommon?.nextToken,
                    argsCommon?.defaultValue
                )
                    .then(data => {
                        let itemTagList = [];
                        let itemSelectedList = [];
                        let ticketMasterList = data?.listTicket
                        let nextToken = data?.nextToken

                        if (Utils.isEmptyArray(ticketMasterList)) {
                            return argsCommon?.setNextToken('done');
                        } 

                        ticketMasterList.forEach(ticket => {
                            let currentItem = tagField.structure?.listItem?.find(
                                o => o.itemId === ticket.id
                            );
                            if (!Utils.isEmptyObject(currentItem)) {

                                let itemData = {
                                    no: Utils.isEmpty(currentItem) ? 1 : currentItem.order,
                                    hitNumber: Utils.isEmpty(currentItem)
                                        ? 0
                                        : currentItem.hitNumber,
                                    title: getTitle(ticket.settingTitle),
                                    value: ticket.id,
                                    isActive:
                                        currentItem.isActive && Utils.isEmpty(ticket?.deletedAt)
                                            ? true
                                            : false,
                                    isDisplayLink: true,
                                    isDeleted: !Utils.isEmpty(ticket?.deletedAt) ? true : false,
                                    isDisplay: ticket.userHasViewPermission ? true : false
                                };

                                if (currentItem.isActive && ticket.userHasViewPermission) {
                                    itemTagList.push(itemData);
                                }


                                
                                if (!Utils.isEmptyArray(argsCommon.defaultValue)) {
                                    if(argsCommon.defaultValue.includes(ticket.id)) {
                                        itemSelectedList.push(itemData);
                                    } else {
                                        for(let i = 0; i < argsCommon.defaultValue.length; i++) {
                                            let field = argsCommon.defaultValue[i];
                                            if(!Utils.isEmptyObject(field) && field.value === ticket.id) {
                                                itemSelectedList.push(itemData);
                                                break;
                                            }
                                        }
                                    }
                                    
                                }
                            }
                        });

                        if (!tagField.structure?.isMultiple) {
                            let selectedItem = Constant.FIELD_UI_SELECT_DEFAULT_ITEM;
                            let indexSelected = 0;
                            if (!Utils.isEmptyArray(itemSelectedList)) {
                                for (let i = 0; i < itemSelectedList.length; i++) {
                                    const itemSelected = itemSelectedList[i];
                                    if (itemSelected.isActive) {
                                        selectedItem = itemSelected;
                                        break;
                                    }
                                }
                            }

                            if (!Utils.isEmptyObject(selectedItem)) {
                                indexSelected = itemTagList.findIndex(
                                    item => item.value === selectedItem.value
                                );
                                itemSelectedList = [selectedItem];
                            } else if (!Utils.isEmptyObject(itemTagList)) {
                                indexSelected = 0;
                                selectedItem = itemTagList[0];
                                itemSelectedList = [selectedItem];
                            } else {
                                itemSelectedList = [];
                            }
                            argsCommon.setDefaultIndexChecked(indexSelected);

                            if (
                                tagField.structure.optionType ===
                                Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
                                || (tagField.structure.optionType === Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE && argsCommon.enableShowMore)
                            ) {
                                itemTagList = [
                                    Constant.FIELD_UI_SELECT_DEFAULT_ITEM,
                                    ...itemTagList
                                ];
                                if (Utils.isEmptyArray(itemSelectedList))
                                    itemSelectedList.push(Constant.FIELD_UI_SELECT_DEFAULT_ITEM);
                            }
                        }

                        if (itemTagList?.length > 0)
                            argsCommon.setTagList(preTagList => {
                                return [...preTagList, ...itemTagList];
                            });

                        if (itemSelectedList?.length > 0) {
                            argsCommon.setTagValue(preItemSelectedList => {
                                return [...preItemSelectedList, ...itemSelectedList];
                            });
                        }
                  
                        if (!nextToken) return argsCommon?.setNextToken('done');
                        argsCommon?.setNextToken(nextToken);
                    })
                    .catch(err => {
                        
                        argsCommon.setTagList([]);
                        argsCommon.setTagValue([]);
                        argsCommon?.setNextToken(null);
                    })
                    .finally(() => {
                        // todo
                        if (setIsDoneInitData) {
                            setIsDoneInitData(true);
                        }
                        if (argsCommon.setIsLoading) {
                            argsCommon.setIsLoading(false);
                        }
                    });
            }
            break;
        default:
            // todo
            break;
    }
};



/**
 * Handle click master knowledge item
 * @param {*} argsCommon 
 * @param {*} masterKnowledgeItem 
 */
export const onClickMasterKnowledgeItem = (argsCommon, masterKnowledgeItem) => {

    // let projectInuseDetail = argsCommon.projectInuseDetail;
    // let currentUserDetail = argsCommon.currentUserDetail;

    // let ticketDetail = argsCommon.detailTicket;

    // let isCustomer = projectInuseDetail.id !== ticketDetail.affiliationProject &&
    //     (currentUserDetail?.id === ticketDetail.customer ||
    //         projectInuseDetail.id === ticketDetail.customer) ? true : false;

    // let type =  Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL
    
    // let currentPanelType = argsCommon?.panelList?.find(panel => panel?.id  === argsCommon?.panelId)
    
    // if(currentPanelType?.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL || currentPanelType?.type === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST ){
        
    //     type = Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
    // };

    if (argsCommon.setLastUserAction) {
        argsCommon.setLastUserAction(LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW);
    }

    argsCommon.addNewPanel({
        // type: isCustomer ? Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
        type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
        tabId: masterKnowledgeItem.id,
        props: argsCommon,
        ticketId: masterKnowledgeItem.id,
        // isCustomer: isCustomer
        ticketOutline: { jp:  masterKnowledgeItem.title}
    });


};


/**
 * Handle click hyper link
 * @param {*} argsCommon 
 */
export const onClickHyperLink = argsCommon => {

    let projectInuseDetail = argsCommon.projectInuseDetail;
    let corporationDetail = argsCommon.corporationDetail;
    let currentUserDetail = argsCommon.currentUserDetail;

    let ticketDetail = argsCommon.detailTicket;
    let fields = JSON.parse(ticketDetail.fields);
    let ticketIdItemList = fields[`${argsCommon.fieldData.id}`];

    let knowledgePanel = argsCommon.panelListRecoilState.find(panel => [
        Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST,
        Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST]
        .includes(panel.type));
    if (Utils.isEmpty(knowledgePanel)) {
        if (
            projectInuseDetail.id !== ticketDetail.affiliationProject &&
            (currentUserDetail?.id === ticketDetail.customer ||
                projectInuseDetail.id === ticketDetail.customer)
        ) {
            argsCommon.addNewPanel({
                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                tabId: 'knowledge_ticket_list_tab',
                visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
                isCustomer: true,
                customerId: ticketDetail.customer,
                projectSelectedId: ticketDetail.affiliationProject,
                corporationSelectedId: ticketDetail.affiliationOrganization,
                ticketIdItemList: typeof ticketIdItemList === 'string' ? JSON.parse(ticketIdItemList) : ticketIdItemList,
                props: argsCommon,
                // link with master knowledge
                masterKnowledgeHyperLink: true
            });
        } else {
            argsCommon.addNewPanel({
                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                tabId: 'knowledge_ticket_list_tab',
                visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.PROJECT,
                isCustomer: false,
                customerId: '',
                projectSelectedId: projectInuseDetail.id,
                corporationSelectedId: projectInuseDetail.affiliationOrganization,
                ticketIdItemList: typeof ticketIdItemList === 'string' ? JSON.parse(ticketIdItemList) : ticketIdItemList,
                props: argsCommon,
                // link with master knowledge
                masterKnowledgeHyperLink: true
            });
        }
    } else {
        let masterKnowledgeHyperLink;
        if (
            projectInuseDetail.id !== ticketDetail.affiliationProject &&
            (currentUserDetail?.id === ticketDetail.customer ||
                projectInuseDetail.id === ticketDetail.customer)
        ) {
            masterKnowledgeHyperLink = {
                isReload: true,

                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
                isCustomer: true,
                customerId: ticketDetail.customer,
                projectSelectedId: ticketDetail.affiliationProject,
                corporationSelectedId: ticketDetail.affiliationOrganization,
                ticketIdItemList: JSON.parse(ticketIdItemList),
                props: argsCommon,
                // link with master knowledge
                masterKnowledgeHyperLink: true
            };
        } else {
            masterKnowledgeHyperLink = {
                isReload: true,

                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.PROJECT,
                isCustomer: false,
                customerId: '',
                projectSelectedId: projectInuseDetail.id,
                corporationSelectedId: projectInuseDetail.affiliationOrganization,
                ticketIdItemList: JSON.parse(ticketIdItemList),
                props: argsCommon,
                // link with master knowledge
                masterKnowledgeHyperLink: true
            };
        }

        // update master knowledge hyper link state
        argsCommon.setMasterKnowledgeHyperLink(masterKnowledgeHyperLink);
    }
};



/**
 * Check show hyperlink
 * @param {*} argsCommon 
 */
export const isShowHyperLink = (argsCommon, ticketItem) => {
    let isShow = false;

    let currentUserDetail = argsCommon.currentUserDetail;

    let publicRange = ticketItem.ticketDetail.publicRange;
    let projectList = argsCommon.projectList;

    // only me
    if (publicRange.includes('user')) {
        isShow = publicRange === currentUserDetail.id
            && argsCommon.projectInuseDetail.id === argsCommon.detailTicket.affiliationProject ? true : false;
        return isShow;
    }

    // project
    if (publicRange.includes('project')) {
        let index = Utils.findIndexInArrayById(publicRange, projectList);
        isShow = index !== -1 && argsCommon.projectInuseDetail.id === argsCommon.detailTicket.affiliationProject ? true : false;
        return isShow;
    }

    // corporation
    if (publicRange.includes('corp')) {
        isShow = publicRange === currentUserDetail.affiliationOrganization && currentUserDetail.type !== Constant.USER_TYPE.CUSTOMER ? true : false;
        return isShow;
    }

    // all
    if (publicRange.includes('ALL')) {
        isShow = true;
        return isShow;
    }


    return isShow;
};

/**
 * Check show see more master knowledge
 * @param {*} argsCommon 
 * @returns isShow
 */
export const isShowSeeMoreMasterKnowledge = argsCommon => {
    if (![Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE].includes(argsCommon.fieldData?.structure?.settingSelectItem)) {
        return false;
    }

    let currentUserDetail = argsCommon.currentUserDetail;
    let projectList = argsCommon.projectList;

    let itemList = JSON.parse(argsCommon.value);
    if (itemList.length <= 1) {
        return false;
    }

    let isShowList = [];
    itemList.map((item, index) => {
        let itemObj = JSON.parse(item);
        let publicRange = itemObj.ticketDetail.publicRange;
        let isShow = false;

        // only me
        if (publicRange.includes('user')) {
            isShow = publicRange === currentUserDetail.id
                && argsCommon.projectInuseDetail.id === argsCommon.detailTicket.affiliationProject ? true : false;
        }

        // project
        if (publicRange.includes('project')) {
            let index = Utils.findIndexInArrayById(publicRange, projectList);
            isShow = index !== -1
                && argsCommon.projectInuseDetail.id === argsCommon.detailTicket.affiliationProject ? true : false;
        }

        // corporation
        if (publicRange.includes('corp')) {
            isShow = publicRange === currentUserDetail.affiliationOrganization && currentUserDetail.type !== Constant.USER_TYPE.CUSTOMER ? true : false;
        }

        // all
        if (publicRange.includes('ALL')) {
            isShow = true;
        }

        if (isShow) {
            isShowList.push(isShow);
        }
    });

    return isShowList.length > 1 ? true : false;
};

